<template>
  <div id="help" :data-active="open" @click="checkShadowClick">
    <div class="modal">
      <div class="modal-header">
        <div class="modal-title">
          {{data.title}}
        </div>
        <div class="modal-close" @click="open = false">
          <img :src="CircleX" alt="fechar" width="32" height="32" />
        </div>
      </div>
      <div class="modal-subtitle">
        {{data.subtitle}}
      </div>
      <div class="modal-content">
        <div v-for="topic in data.content">
          <h2>{{topic[0]}}</h2>
          <p v-html="topic[1]" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CircleX from 'Assets/images/circle-x.svg';
  import EventSystem from '../utils/EventSystem';

  export default {
    components: {
    },
    // Vars
    props: {},
    data() {
      return {
        CircleX,
        open: false,
        data: {
          title: '???',
          content: '???',
        }
      };
    },

    // Lifecyle
    created() {
      EventSystem.$on('keypress-esc', () => {
        this.open = false;
      });

      EventSystem.$on('modal-open', data => {
        this.open = true;
        this.data = data;
      });
    },

    // Methods
    computed: {},
    methods: {
      checkShadowClick(evt) {
        try {
          if (evt.target.getAttribute('id') === 'help') {
            this.open = false;
          }
        } catch(_) {}
      }
    },
  };
</script>





// WEBPACK FOOTER //
// assets/js/source/vue-ui/modal.vue